import { useSelector } from 'react-redux';
import { Box, Flex } from '@chakra-ui/react';
import DynamicTable from '../table/DynamicTable';
import SettingsTabs from '../tabs/SettingsTabs';
import SubTabsWithOrder from '../tabs/SubTabsWithOrder';
import Toolbar from './Toolbar';
import Calendar from '../calendar/Calendar';
import { TState } from '../../redux/store';
import StatsSettings from '../stats/StatsSettings';
import Loader from '../common/Loader';

const Main = () => {
  const currentTab = useSelector((state: TState) => state.currentTab);
  const isEditMode = useSelector((state: TState) => state.isEditMode);
  const theme = useSelector((state: TState) => state.theme);

  const customTab =
    currentTab?.isSetting ||
    currentTab?.isPlanning ||
    currentTab?.isDuplicate ||
    currentTab?.isStats;

  return (
    <Flex
      flexDirection='column'
      flexGrow={1}
      w={0}
      px={theme.margin}
      mb={['16px', '24px']}
      overflow='hidden'
    >
      <Toolbar />
      {!currentTab && !customTab ? (
        <Loader />
      ) : (
        <Box flexGrow={1} overflow='hidden'>
          <Flex
            position='relative'
            zIndex={0}
            overflow='hidden'
            id='mainContainer'
            h='100%'
            flexDirection='column'
          >
            {customTab ? null : isEditMode ? (
              <SubTabsWithOrder />
            ) : (
              <DynamicTable />
            )}
            {!isEditMode && currentTab?.isStats && <StatsSettings />}
            {!isEditMode && currentTab?.isSetting && <SettingsTabs />}
            {currentTab?.isPlanning &&
              (isEditMode ? <SubTabsWithOrder /> : <Calendar />)}
            {currentTab?.isDuplicate &&
              (isEditMode ? <SubTabsWithOrder /> : <DynamicTable />)}
          </Flex>
        </Box>
      )}
    </Flex>
  );
};

export default Main;
